import {
  BaseExportParams,
  ExcelExportParams,
  ProcessCellForExportParams,
  ProcessHeaderForExportParams,
} from "@ag-grid-community/core";
import { GenericTableCell } from "gen/model/genericTableCell";
import { DataTableContext } from "shared/components/table/data/DataTableContext";
import {
  GenericTableAgGridReactProps,
  isPaginationRow,
} from "shared/components/table/data/DataTableTypes";
import { valueForCellExport } from "shared/components/table/data/internal/DataTableInternalUtils";
import { DEFAULT_EXPORT_TITLE } from "shared/components/table/maybern/MaybernTableExport";

const processCellCallback = (params: ProcessCellForExportParams) => {
  if (typeof params.value === "string") {
    return params.value;
  } else if (typeof params.value === "object") {
    return valueForCellExport(params.value as GenericTableCell);
  }
  return "";
};

const exportParams: BaseExportParams = {
  processCellCallback,
  shouldRowBeSkipped: (params) => {
    const tableContext = params.context as DataTableContext;
    return tableContext.isClientRowAggregation
      ? isPaginationRow(params.node.data) || params.node.level > 0
      : isPaginationRow(params.node.data);
  },
  processHeaderCallback: (params: ProcessHeaderForExportParams) =>
    params.api.getDisplayNameForColumn(params.column, null),
  processRowGroupCallback: (params) => {
    const cells: Record<string, GenericTableCell> | undefined =
      params.node.aggData;
    const cell =
      params.node.field && cells ? cells[params.node.field] : undefined;
    const cellValue = cell ? valueForCellExport(cell) : undefined;
    return cellValue ?? params.node.key ?? "-";
  },
};

const defaultExcelExportParams: ExcelExportParams = {
  ...exportParams,
  sheetName: DEFAULT_EXPORT_TITLE,
  allColumns: true, // NOTE: Columns filtered by agGridParamsForExcelExport()
};

export const dataTableAgPropsExport: Partial<GenericTableAgGridReactProps> = {
  processCellForClipboard: processCellCallback,
  defaultCsvExportParams: exportParams,
  defaultExcelExportParams,
};
